import createIcon from '../../createIcon';

/**
 * @component @name DeleteForever
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAxOUM2IDIwLjEgNi45IDIxIDggMjFIMTZDMTcuMSAyMSAxOCAyMC4xIDE4IDE5VjdINlYxOVpNOC40NiAxMS44OEw5Ljg3IDEwLjQ3TDEyIDEyLjU5TDE0LjEyIDEwLjQ3TDE1LjUzIDExLjg4TDEzLjQxIDE0TDE1LjUzIDE2LjEyTDE0LjEyIDE3LjUzTDEyIDE1LjQxTDkuODggMTcuNTNMOC40NyAxNi4xMkwxMC41OSAxNEw4LjQ2IDExLjg4Wk0xNS41IDRMMTQuNSAzSDkuNUw4LjUgNEg1VjZIMTlWNEgxNS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DeleteForever = createIcon('DeleteForever', [
  [
    'path',
    {
      d: 'M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8.46 11.88L9.87 10.47L12 12.59L14.12 10.47L15.53 11.88L13.41 14L15.53 16.12L14.12 17.53L12 15.41L9.88 17.53L8.47 16.12L10.59 14L8.46 11.88ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z',
      key: '12nwud',
    },
  ],
]);

export default DeleteForever;
